import { tv } from '../tw';

const dropdownContent = tv({
  base: 'bg-surface-input w-[260px] rounded-sm border border-neutral-subtle'
});

export { dropdownContent };
